import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'font-awesome/css/font-awesome.min.css'
import '@/style/main.css'
import * as ElementPlusIcons from '@element-plus/icons-vue';
import { VueSignaturePad } from 'vue-signature-pad'
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate) // 启用持久化插件
const app = createApp(App)
// 批量注册所有图标组件
for (const [key, component] of Object.entries(ElementPlusIcons)) {
    app.component(key, component);
}
app.use(pinia)
app.use(router)
app.use(ElementPlus)
app.use(VueSignaturePad)
// 全局错误处理
app.config.errorHandler = (err) => {
    console.error('Global error:', err);
};
app.mount('#app')
